import React from "react";
import { Tabs } from "@mantine/core";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Shopify from "./Shopify";
import ShopifyIntegrations from "./ShopifyIntegrations";

const ShopifyTabs = () => {
  const [_] = useTranslation("global");

  return (
    <Tabs defaultValue="links" className="w-100">
      <Helmet>
        <title>{_("panel.shopify")}</title>
      </Helmet>
      <Tabs.List>
        <Tabs.Tab value="links" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.link")}
        </Tabs.Tab>
        <Tabs.Tab value="integrations" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.keys")}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="links">
        <Shopify />
      </Tabs.Panel>

      <Tabs.Panel value="integrations">
        <ShopifyIntegrations />
      </Tabs.Panel>
    </Tabs>
  );
};

export default ShopifyTabs;
